import React, { FC, ReactNode, useEffect } from "react";
import { compose } from "redux";
import cn from "clsx";

import { stormlyKey } from "../../config/app";
import {
  getStatesData,
  setCountryFromUrl,
  updateLanguageName
} from "../../redux/actions/common.action";
import withDefaultLanguageHandling from "../../hocs/withDefaultLanguageHandling";
import StormlyService from "../../services/StormlyService";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { useCountryShort, useIsRTL, useLanguage } from "@/hooks";
const AppContainer: FC<{ children: ReactNode }> = ({ children }) => {
  const storeLanguage = useAppSelector(store => store.common.language);
  const storeCountryShort = useAppSelector(
    store => store.common.countryFromUrl
  );
  const language = useLanguage();
  const countryShort = useCountryShort();
  const countryId = useAppSelector(state => state.common.settings.countryId);
  const dispatch = useAppDispatch();
  const isRTL = useIsRTL();

  useEffect(() => {
    if (storeLanguage !== language) {
      dispatch(updateLanguageName(language));
    }
    if (storeCountryShort !== countryShort) {
      dispatch(setCountryFromUrl(countryShort));
    }
  }, []);

  useEffect(() => {
    countryId && dispatch(getStatesData(countryId, language));

    StormlyService.loadAnaliticsScript(stormlyKey);
  }, [countryId]);

  return (
    <div className={cn("parent-container", { arabic: isRTL })}>{children}</div>
  );
};
export default compose(
  withDefaultLanguageHandling
  //@ts-ignore
)(AppContainer);
